import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import englishTranslation from "./locales/en/translation.json";
import frenchTranslation from "./locales/fr/translation.json";

i18n.on("languageChanged", function lng() {
  let basePath = window.location.pathname + window.location.search;
  const languages = Object.keys(i18n.store.data);

  languages.forEach(function getBase(langCode) {
    if (basePath.indexOf(`/${langCode}`) === 0) {
      basePath = basePath.substr(`/${langCode}`.length);
    }
  });

  window.history.replaceState(
    {},
    document.title,
    `/${i18n.language}${basePath}`
  );
});

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources: {
      en: {
        translation: englishTranslation,
      },
      fr: {
        translation: frenchTranslation,
      },
    },
    whitelist: ["en", "fr"],
    fallbackLng: ["en"],
    detection: {
      order: ["path", "cookie", "navigator"],
      lookupFromPathIndex: 0,
      checkWhitelist: true,
      lookupCookie: "lang",
      cookieMinutes: 60 * 24 * 30,
      cookieDomain:
        // eslint-disable-next-line no-undef
        LANG_COOKIE_DOMAIN !== undefined ? LANG_COOKIE_DOMAIN : null,
      caches: ["cookie"],
    },

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
